import { QuanLyHaTangKyThuatAction } from "./quanlyhatangkythuat.action-rule";
import { QuanLyHaTangKyThuatActiontype } from "./quanlyhatangkythuat.action-types";
import { TabIndex } from './models/quanlyhatangkythuat.model';

export type QuanLyHaTangKyThuatModel = {
  tabindex: TabIndex,
  listDAHDXD: __esri.Graphic[],
  dataCount: number
};



export const quanLyHaTangKyThuatDefaultState: QuanLyHaTangKyThuatModel = {
  tabindex: TabIndex.CapPhepXayDung,
  listDAHDXD: [],
  dataCount: 0
};

function reducer(state: QuanLyHaTangKyThuatModel = quanLyHaTangKyThuatDefaultState, action: QuanLyHaTangKyThuatAction): QuanLyHaTangKyThuatModel {
  switch (action.type) {
    case QuanLyHaTangKyThuatActiontype.ChangeTabindexActiontype:
      return { ...state, tabindex: action.index };
    case QuanLyHaTangKyThuatActiontype.GetListHDXD:
      return { ...state, listDAHDXD: action.listDAHDXD };
    case QuanLyHaTangKyThuatActiontype.GetDataCount:
      return { ...state, dataCount: action.dataCount };
    default:
      return state;
  }
}

export default reducer;